import React from "react";
import { Table, Spinner } from "react-bootstrap";

const TableUI = ({
  headers = [],
  body = [],
  columns = null,
  data = null,
  className = "",
  showActionColumn = true,
  noRecordMessage = "No Record Found",
  showHeaders = true,
  progressPending = false,
}) => {
  const isColumnsMode = Array.isArray(columns);

  const renderHeaders = () => {
    if (!showHeaders) return null;

    if (isColumnsMode) {
      return (
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={col.id || col.name || index} style={{ width: col.width }}>
                {col.name}
              </th>
            ))}
          </tr>
        </thead>
      );
    }

    const safeHeaders = Array.isArray(headers) ? headers : [];
    return (
      <thead>
        <tr>
          {safeHeaders.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
          {showActionColumn && <th>Actions</th>}
        </tr>
      </thead>
    );
  };

  const renderBody = () => {
    if (progressPending) {
      const colSpanCount = isColumnsMode
        ? columns.length
        : (Array.isArray(headers) ? headers.length : 0) + (showActionColumn ? 1 : 0);
      return (
        <tr className="text-center">
          <td colSpan={colSpanCount} className="py-4">
            <Spinner animation="border" variant="primary" size="sm" className="me-2" />
            <span>Loading data...</span>
          </td>
        </tr>
      );
    }

    if (isColumnsMode) {
      const rowDataList = Array.isArray(data) ? data : [];
      if (rowDataList.length === 0) {
        return (
          <tr className="text-center">
            <td colSpan={columns.length} className="py-3 text-muted">
              {noRecordMessage}
            </td>
          </tr>
        );
      }

      return rowDataList.map((row, rowIndex) => (
        <tr key={row.id || rowIndex}>
          {columns.map((col, colIndex) => {
            let val = "";
            if (typeof col.cell === "function") {
              val = col.cell(row, rowIndex);
            } else if (typeof col.selector === "function") {
              val = col.selector(row, rowIndex);
            } else if (col.accessor) {
              val = row[col.accessor];
            }

            return (
              <td key={colIndex} style={{ width: col.width }}>
                {val}
              </td>
            );
          })}
        </tr>
      ));
    }

    // Legacy headers + body mode
    const bodyList = Array.isArray(body) ? body : [];
    const safeHeaders = Array.isArray(headers) ? headers : [];
    const colSpanCount = safeHeaders.length + (showActionColumn ? 1 : 0);

    if (bodyList.length === 0) {
      return (
        <tr className="text-center">
          <td colSpan={colSpanCount} className="py-3 text-muted">
            {noRecordMessage}
          </td>
        </tr>
      );
    }

    return bodyList.map((rowData, rowIndex) => (
      <tr key={rowData.key || rowIndex}>
        {(rowData.values || []).map((rowValue, colIndex) => (
          <td key={colIndex}>{rowValue}</td>
        ))}
      </tr>
    ));
  };

  return (
    <Table responsive="md" hover className={`align-middle ${className}`}>
      {renderHeaders()}
      <tbody>{renderBody()}</tbody>
    </Table>
  );
};

export default TableUI;
